import { RepairsActions } from "../action-types/repairsActionType";

const initialState = {
  repairstData: [],
  repairsdefectstDetailsData: [],
  repairstPaginationData: []
};

const repairsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RepairsActions.SET_REPAIRS_LIST:
      return {
        ...state,
        repairstData: action.payload,
      };
    case RepairsActions.SET_REPAIRS_LIST_PAGINATION:
      return {
        ...state,
        repairstPaginationData: action.payload,
      };
    case RepairsActions.SET_REPAIRS_DEFECTS_DETAILS_BY_ID_LIST:
      return {
        ...state,
        repairsdefectstDetailsData: action.payload,
      };
    default:
      return state;
  }
};

export default repairsReducer;
